import * as React from 'react'

import {type PolyfilledEvent} from '@frontrow/console/src/polyfills'
import {Button, type Props as ButtonProps} from '@frontrow/console/src/components/button'

type Props = {
  onClick: (e: PolyfilledEvent) => Promise<unknown>
} & ButtonProps

export function ButtonAsync(props: Props) {
  const {onClick: onClickFromProps, disabled: initDisabled, children, ...buttonProps} = props

  const [disabled, setDisabled] = React.useState<boolean>(initDisabled ?? false)

  React.useEffect(() => {
    setDisabled(initDisabled ?? false)
  }, [initDisabled])

  const onClick = (e: PolyfilledEvent) => {
    if (disabled) {
      e.preventDefault()
    } else {
      setDisabled(true)
      const promise = onClickFromProps(e)
      promise.then(() => setDisabled(false))
    }
  }

  return (
    <Button {...buttonProps} disabled={disabled} onClick={onClick}>
      {children}
    </Button>
  )
}
